<script lang="ts">
    import router from "page";

    export let updatedAt: number;
    export let name: string;
    export let offerCount: number;
    export let key: string;
    export let isHover: boolean;
    import Fa from 'svelte-fa'
    // import { faFolder } from '@fortawesome/free-solid-svg-icons';
    import { faFolderOpen } from '@fortawesome/free-regular-svg-icons'

</script>
<div 

class="
w3-col
 hover:bg-secondary 
 hover:text-white
"
on:click={()=>{
    router.show("/offers?offerOwner=" + key);
}}
on:mouseenter={()=>{
    isHover = true
}}
on:mouseleave={()=>{
    isHover = false
}}
>
    <div title={`${name} last updated at ${new Date(updatedAt).toDateString()}`} class="ownerItem" >
        <Fa icon={faFolderOpen} color={isHover? 'white' : 'peachpuff'} size="6x" swapOpacity={false}/>
        <span class="ownerTitle">{name}</span>
        <small>{offerCount + " Offer" + (offerCount > 1 ? "s" : "")} </small> 
        
    </div>
</div>

<style>
.ownerItem{
    display: flex; 
    margin-bottom: 0.5rem; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
    width: fit-content;
}

.ownerTitle{
    text-align: center;
    max-width: 100%;
}
.w3-col{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
    }
</style>